module.exports = __webpack_public_path__ + "img/full3-min.4c3cf965.png";